import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../Header/Header.module.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // Get the current location

  // Close the menu when the route changes
  useEffect(() => {
    setIsMenuOpen(false); // Close the menu
  }, [location]); // The menu will close every time the location changes

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const styleClass =
  ['/contact','/blog', '/payment-gateways-management', '/fleet-management', '/multivendor-ecommerce-solutions', '/analytics-and-reporting', '/role-management', '/interdevice-communications-management']
    .includes(location.pathname) || location.pathname.startsWith('/blog/')
    ? styles.headerStyle2
    : location.pathname === "*" // Apply headerStyle2 for NotFound (404) routes
    ? styles.headerStyle2
    : styles.headerStyle1;


  return (
    <header className={styleClass}>
      <div className={styles.container}>
        <div className={styles.siteLogo_desktop}>
          <div>
            <Link to="/">
              <img
                src="/assets/NinjasCode-logo.webp"
                alt="Ninjascode"
                width="100%"
                height="100%"
              />
            </Link>
          </div>
        </div>
        <div className={styles.hamburger} onClick={toggleMenu}>
          {isMenuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="24"
              height="24"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="24"
              height="24"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          )}
        </div>
        <nav
          className={`${styles.nav} ${
            isMenuOpen ? styles.navOpen : styles.navClosed
          }`}
        >
          <div className={styles.siteLogo_mobile}>
            <div>
              <Link to="/">
                <img
                  src="assets/NinjasCode-logo.webp"
                  alt="Ninjascode"
                  width="100%"
                  height="100%"
                />
              </Link>
            </div>
          </div>
          
                    {/* Specialities Dropdown */}
                    <div className={styles.dropdown}>
            <span className={styles.dropdownTrigger}>
              Our Specialities{" "}
              <span className="chevron-down-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                </svg>
              </span>
            </span>
            <div className={styles.dropdownMenu}>
              <Link to="/payment-gateways-management">Payment Gateways Management
              </Link>
              <Link to="/fleet-management">Fleet Management
              </Link>
              <Link to="/multivendor-ecommerce-solutions">Multivendor E-commerce Solutions
              </Link>
              <Link to="/analytics-and-reporting">Analytics and Reporting
              </Link>
              <Link to="/role-management">Role Management
              </Link>
              <Link to="/interdevice-communications-management">Interdevice Communications Management
              </Link>
            </div>
          </div>

          {/* Case Studies Dropdown */}
          <div className={styles.dropdown}>
            <span className={styles.dropdownTrigger}>
              Case Studies{" "}
              <span className="chevron-down-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                </svg>
              </span>
            </span>
            <div className={styles.dropdownMenu}>
              <Link to="/borku">Borku</Link>
              <Link to="/yalla">Yalla</Link>
      
              <Link to="/groove-packer">Groove Packer</Link>
            </div>
          </div>
          <Link to="/#pricing">Pricing</Link>
          <Link to="/blog">Blog</Link>
         
          <div className={styles.headerCta_mobile}>
          <Link to="/contact">Get a Quote</Link>
          </div>
        </nav>
        <div className={styles.headerCta_desktop}>
        <Link to="/contact">Get a Quote</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
